import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { EMPTY_FUNCTION } from 'support/helpers/const/const';
import { InvoiceVerificationDTO } from 'support/types';

/**
 * Custom hook that handles form validation timing and triggers
 * Automatically triggers form validation after form setup with a small delay
 */
export const useFormValidationTrigger = (
  formMethods: UseFormReturn<Required<InvoiceVerificationDTO>['payload']>,
  payload: InvoiceVerificationDTO['payload'],
) => {
  useEffect(() => {
    // Small delay to ensure form is properly initialized before validation
    const timeoutId = setTimeout(() => {
      formMethods.handleSubmit(EMPTY_FUNCTION)();
    }, 10);

    return () => clearTimeout(timeoutId);
  }, [formMethods, payload]);
};
